export const device = {
    lg: '(max-width: 1280px)',
    md: '(max-width: 960px)',
    sm: '(max-width: 600px)',
}
